/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type LogoutBhActionActionType =
  (typeof LogoutBhActionActionType)[keyof typeof LogoutBhActionActionType];

export const LogoutBhActionActionType = {
  logout: 'logout',
} as const;
